import React from 'react';
import { useBranding } from '@/hooks/useBranding';
import BrandingUploader from './BrandingUploader';

const LogoUploader: React.FC = () => {
  const { logo, uploadBrandingFile, resetToDefault } = useBranding();

  return (
    <BrandingUploader
      label="Website Logo"
      currentUrl={logo?.file_url}
      acceptedTypes="image/png, image/jpeg, image/jpg, image/gif, image/svg+xml"
      acceptedTypesLabel="PNG, JPG, JPEG, GIF, SVG"
      maxSizeKb={2048}
      recommendedSize="400x100px"
      onUpload={async (file) => {
        const result = await uploadBrandingFile('logo', file);
        return result.fileUrl;
      }}
      onReset={async () => resetToDefault('logo')}
      previewHeight="h-40"
    />
  );
};

export default LogoUploader;
